import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const STATUS = 'VOICE_TO_TEXT/STATUS';

/**
 * When voice to text server is `listening` it means
 * it is ready to receive `START` event to switch to
 * recognising mode
 *
 * When voice to text server is `recognising` it means
 * it is currently generating `RESULT` events until one
 * of the events get `isFinal` status and trigger a message
 */
export type Status = 'listening' | 'recognizing';

export const statusSchema = Joi.string().valid('listening', 'recognizing');

export const statusPayloadSchema = objectSchemaOf<IStatusPayload>({
  conversationId: Joi.string().required(),
  status: statusSchema.required(),
  timestamp: Joi.number().required(),
});

export interface IStatusPayload {
  conversationId: string;
  status: Status;
  timestamp: number;
}

export const statusActionSchema = objectSchemaOf<IStatusAction>({
  type: Joi.string().required().valid(STATUS),
  payload: statusPayloadSchema.required(),
});

export interface IStatusAction {
  type: typeof STATUS;
  payload: IStatusPayload;
}

export const status = actionCreator({
  type: STATUS,
  schema: statusActionSchema,
});
